import SecondaryButton from '../components/SecondaryButton/SecondaryButton';
import libraryStyles from '../SCSS/Library.module.scss';
import { ClassroomType, AddStudentModeType } from '@peekapak/types/DataProtocolTypes';

interface Props {
  classroom: ClassroomType;
}

const SwitchButton = ({ classroom, ...props }: Props) => {
  const switchOn = classroom && classroom.addStudentMode;

  if (!switchOn) {
    return null;
  }

  let target = 'manual',
    text = 'Switch to Manual Mode';

  if (classroom.addStudentMode === AddStudentModeType.MANUAL) {
    target = 'classCode';
    text = 'Switch to Class Code Mode';
  }

  return (
    <>
      {props.textButton ? (
        <div onClick={() => props.onUpdateAddStudentMode(target)} className={libraryStyles.textLink}>
          {text}
        </div>
      ) : (
        <SecondaryButton small onClick={() => props.onUpdateAddStudentMode(target)} className={props.buttonClass}>
          {text}
        </SecondaryButton>
      )}
    </>
  );
};

export default SwitchButton;
